import { Button, ButtonGroup } from '@customerio/pluma-components/react';

type WizardActionsProps = {
  backLabel: string;
  nextLabel: string;
  /** When set, "Next" submits this form instead of calling `onNext`. */
  formId?: string;
  isNextDisabled: boolean;
  isNextLoading?: boolean;
  /** Accepted so the footer can be spread from `wizardActionState`; the buttons read `formId` and `onNext`. */
  withNext?: boolean;
  /** Accepted so the footer can be spread from `wizardActionState`; the Skip button reads `onSkip`. */
  withSkip?: boolean;
  onBack: () => void;
  onNext?: () => void;
  /** When set, a "Skip" button sits before the forward action. */
  onSkip?: () => void;
};

/** The step footer: back (or cancel) on the left, the forward action on the right. */
export function WizardActions({
  backLabel,
  nextLabel,
  formId,
  isNextDisabled,
  isNextLoading = false,
  withNext: _withNext,
  withSkip: _withSkip,
  onBack,
  onNext,
  onSkip,
}: WizardActionsProps) {
  return (
    <ButtonGroup groupVariant="spaced" display="flex">
      <Button variant="tertiary" onClick={onBack} mr="auto" data-test-sql-import-button="back">
        {backLabel}
      </Button>
      {onSkip == null ? null : (
        <Button variant="secondary" onClick={onSkip} data-test-sql-import-button="skip">
          Skip
        </Button>
      )}
      {formId == null ? (
        <Button
          variant="primary"
          onClick={onNext}
          isDisabled={isNextDisabled}
          isLoading={isNextLoading}
          data-test-sql-import-button="submit"
        >
          {nextLabel}
        </Button>
      ) : (
        <Button
          variant="primary"
          type="submit"
          form={formId}
          isDisabled={isNextDisabled}
          data-test-sql-import-button="submit"
        >
          {nextLabel}
        </Button>
      )}
    </ButtonGroup>
  );
}
